'use client';

import type { ComponentType } from 'react';
import type { SectionBlock, PageBlock } from '@impact/types';
import type { EditableWrapper } from '../types';
import { BlockRenderer } from '../BlockRenderer';

interface Props {
  block: SectionBlock;
  editing?: boolean;
  Wrapper?: EditableWrapper;
}

export function SectionDiagonalMask({ block, editing, Wrapper }: Props) {
  return (
    <section
      className="relative bg-primary py-24 text-primary-foreground"
      style={{ clipPath: 'polygon(0 0, 100% 4%, 100% 96%, 0 100%)' }}
    >
      <div className="relative z-10 mx-auto max-w-5xl px-4">
        {block.data.blocks.map((child: PageBlock) => (
          <BlockRenderer key={child.id} block={child} editing={editing} Wrapper={Wrapper} />
        ))}
      </div>
    </section>
  );
}
